import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {PriceListState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class PriceListQuery extends QueryEntity<PriceListState> {

  constructor(protected store: Store) {
    super(store);
  }

}
